import PropTypes from 'prop-types';
/**
 * Common PropTypes for all react-admin inputs
 */
var InputPropTypes = {
    label: PropTypes.string,
    resource: PropTypes.string,
    source: PropTypes.string,
};
export default InputPropTypes;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-ui-materialui/esm/input/InputPropTypes.js
// module id = 561
// module chunks = 0